export default {"src":"/_next/static/media/mastercard.9aa57b1b.svg","height":618,"width":1000,"blurWidth":0,"blurHeight":0};